<template>
  <div><el-empty description="当前暂无论坛信息"></el-empty></div>
</template>
  
  <script>
export default {
  name: "NotFoundPage", // 修改组件名称
};
</script>
  
  <style>
/* 样式内容 */
</style>